import ApiService from "../../../../commons/services/ApiService";
import CompanyAPI from "../../../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();

export default class AnamneseAPI {

  URI_V1 = "/v1/anamnese"

  generate = async (data: any) => {
    return await apiService.post(`${this.URI_V1}/generate`, data);
  };

  list = async (filters: any = {}) => {
    const companyId = companyAPI.getCompanyManagment().id;

    // normaliza e não manda vazio
    const params: any = {
      companyId,
      page: filters.page ?? 0,
      size: filters.size ?? 10,
    };

    if (filters.q) params.q = String(filters.q).trim();
    if (filters.templateId) params.templateId = filters.templateId;
    if (filters.dateType) params.dateType = filters.dateType; // CREATE_DT | FILLED_DT
    if (filters.dateFrom) params.dateFrom = filters.dateFrom; // yyyy-MM-dd
    if (filters.dateTo) params.dateTo = filters.dateTo;       // yyyy-MM-dd

    return await apiService.get(`${this.URI_V1}/list`, { params });
  };

  delete = async (id: any) => {
    return await apiService.delete(`${this.URI_V1}/${id}`);
    // ou: `${this.URI_V1}/delete/${id}` dependendo do seu backend
  };

  getById = async (id: any) => {
    return await apiService.get(`${this.URI_V1}/${id}`);
  };

  generatePDF = async (id: any) => {
    return apiService.get(`${this.URI_V1}/${id}/pdf`, {
      responseType: "blob",
      headers: {
        Accept: "application/pdf",
      },
    });
  };

  saveDiagnostic = async (id: any, data: any) => {
    return await apiService.put(`${this.URI_V1}/${id}/diagnostic`, data);
  };

  addProtocolToResponse = async (id: any, protocolId: any) => {
    return await apiService.put(`${this.URI_V1}/${id}/add-protocol?protocolId=${protocolId}`, null);
  };

  getProtocols = async (id: any) => {
    return await apiService.get(`${this.URI_V1}/${id}/protocols`);
  };

  removeProtocolFromResponse = async (id: any, protocolId: any) => {
    return await apiService.delete(`${this.URI_V1}/${id}/remove-protocol?protocolId=${protocolId}`);
  };

}
